/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Delete_HintInputs */



/**
* | output |
* | --- |
* | "Once you delete a team, all members will lose access to spaces shared with this team. This action cannot be undone." |
*
* @param {Teams_Delete_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_delete_hint = /** @type {((inputs?: Teams_Delete_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Delete_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn du ein Team löschst, verlieren alle Mitglieder den Zugriff auf die mit diesem Team geteilten Spaces. Diese Aktion kann nicht rückgängig gemacht werden.")
	return /** @type {LocalizedString} */ ("Once you delete a team, all members will lose access to spaces shared with this team. This action cannot be undone.")
});